const MembersData = [{
  member: {
    avatar: '300-3.png',
    name: 'Tyler Hero',
    tasks: '26'
  },
  location: {
    name: 'Estonia',
    flag: 'estonia.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Current session'
}, {
  member: {
    avatar: '300-2.png',
    name: 'Esther Howard',
    tasks: '639'
  },
  location: {
    name: 'Malaysia',
    flag: 'malaysia.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-11.png',
    name: 'Jacob Jones',
    tasks: '125'
  },
  location: {
    name: 'Ukraine',
    flag: 'ukraine.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Today, 9:53 am'
}, {
  member: {
    avatar: '300-2.png',
    name: 'Cody Fisher',
    tasks: '81'
  },
  location: {
    name: 'Canada',
    flag: 'canada.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Current session'
}, {
  member: {
    avatar: '300-5.png',
    name: 'Leslie Alexander',
    tasks: '203'
  },
  location: {
    name: 'India',
    flag: 'india.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Month ago'
}, {
  member: {
    avatar: '300-6.png',
    name: 'Brooklyn Simmons',
    tasks: '45'
  },
  location: {
    name: 'Spain',
    flag: 'spain.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 3:45 pm'
}, {
  member: {
    avatar: '300-7.png',
    name: 'Darlene Robertson',
    tasks: '108'
  },
  location: {
    name: 'Germany',
    flag: 'germany.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: '2 days ago'
}, {
  member: {
    avatar: '300-8.png',
    name: 'Jerome Bell',
    tasks: '91'
  },
  location: {
    name: 'France',
    flag: 'france.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-9.png',
    name: 'Devon Lane',
    tasks: '56'
  },
  location: {
    name: 'Japan',
    flag: 'japan.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 11:00 am'
}, {
  member: {
    avatar: '300-10.png',
    name: 'Jane Cooper',
    tasks: '47'
  },
  location: {
    name: 'South Korea',
    flag: 'south-korea.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: '3 days ago'
}, {
  member: {
    avatar: '300-12.png',
    name: 'Ronald Richards',
    tasks: '64'
  },
  location: {
    name: 'Brazil',
    flag: 'brazil.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Month ago'
}, {
  member: {
    avatar: '300-13.png',
    name: 'Kathryn Murphy',
    tasks: '78'
  },
  location: {
    name: 'United Kingdom',
    flag: 'united-kingdom.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 10:30 am'
}, {
  member: {
    avatar: '300-14.png',
    name: 'Jacob Smith',
    tasks: '92'
  },
  location: {
    name: 'Australia',
    flag: 'australia.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-15.png',
    name: 'Kristin Watson',
    tasks: '102'
  },
  location: {
    name: 'Italy',
    flag: 'italy.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Today, 8:00 am'
}, {
  member: {
    avatar: '300-16.png',
    name: 'Cameron Williamson',
    tasks: '58'
  },
  location: {
    name: 'Russia',
    flag: 'russia.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: '2 days ago'
}, {
  member: {
    avatar: '300-17.png',
    name: 'Courtney Henry',
    tasks: '75'
  },
  location: {
    name: 'India',
    flag: 'india.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Month ago'
}, {
  member: {
    avatar: '300-18.png',
    name: 'Ralph Edwards',
    tasks: '109'
  },
  location: {
    name: 'Spain',
    flag: 'spain.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-19.png',
    name: 'Arlene McCoy',
    tasks: '84'
  },
  location: {
    name: 'Canada',
    flag: 'canada.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 1:00 pm'
}, {
  member: {
    avatar: '300-20.png',
    name: 'Theresa Webb',
    tasks: '56'
  },
  location: {
    name: 'Malaysia',
    flag: 'malaysia.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-21.png',
    name: 'Guy Hawkins',
    tasks: '68'
  },
  location: {
    name: 'Estonia',
    flag: 'estonia.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Today, 3:00 pm'
}, {
  member: {
    avatar: '300-22.png',
    name: 'Floyd Miles',
    tasks: '43'
  },
  location: {
    name: 'Ukraine',
    flag: 'ukraine.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 11:45 am'
}, {
  member: {
    avatar: '300-23.png',
    name: 'Devon Lane',
    tasks: '91'
  },
  location: {
    name: 'India',
    flag: 'india.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Month ago'
}, {
  member: {
    avatar: '300-24.png',
    name: 'Ronald Richards',
    tasks: '78'
  },
  location: {
    name: 'France',
    flag: 'france.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-25.png',
    name: 'Kathryn Murphy',
    tasks: '85'
  },
  location: {
    name: 'Japan',
    flag: 'japan.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 4:00 pm'
}, {
  member: {
    avatar: '300-26.png',
    name: 'Jacob Smith',
    tasks: '92'
  },
  location: {
    name: 'South Korea',
    flag: 'south-korea.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-27.png',
    name: 'Kristin Watson',
    tasks: '102'
  },
  location: {
    name: 'Italy',
    flag: 'italy.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Today, 8:00 am'
}, {
  member: {
    avatar: '300-28.png',
    name: 'Cameron Williamson',
    tasks: '58'
  },
  location: {
    name: 'Russia',
    flag: 'russia.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: '2 days ago'
}, {
  member: {
    avatar: '300-29.png',
    name: 'Courtney Henry',
    tasks: '75'
  },
  location: {
    name: 'Spain',
    flag: 'spain.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Month ago'
}, {
  member: {
    avatar: '300-30.png',
    name: 'Ralph Edwards',
    tasks: '109'
  },
  location: {
    name: 'Canada',
    flag: 'canada.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-31.png',
    name: 'Arlene McCoy',
    tasks: '84'
  },
  location: {
    name: 'Malaysia',
    flag: 'malaysia.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 1:00 pm'
}, {
  member: {
    avatar: '300-32.png',
    name: 'Theresa Webb',
    tasks: '56'
  },
  location: {
    name: 'Estonia',
    flag: 'estonia.svg'
  },
  status: {
    label: 'On Leave',
    variant: 'badge-danger'
  },
  recentlyActivity: 'Week ago'
}, {
  member: {
    avatar: '300-33.png',
    name: 'Guy Hawkins',
    tasks: '68'
  },
  location: {
    name: 'Ukraine',
    flag: 'ukraine.svg'
  },
  status: {
    label: 'Remote',
    variant: 'badge-primary'
  },
  recentlyActivity: 'Today, 3:00 pm'
}, {
  member: {
    avatar: '300-34.png',
    name: 'Floyd Miles',
    tasks: '43'
  },
  location: {
    name: 'India',
    flag: 'india.svg'
  },
  status: {
    label: 'In Office',
    variant: 'badge-success'
  },
  recentlyActivity: 'Today, 11:45 am'
}];

const tableData = [
  {
    id: 1,
    firstName: "Sophia",
    MiddleName: "Marie",
    lastName: "Anderson",
    HomeNumber: "327-415-6823",
    OfficeNumber: "542-762-1987",
    PhoneNumber: "+1 893 562 147",
    Fax: "193-274-8563",
    email: "user1@example.com",
    address: "152 Oak St, Springfield",
    state: "Washington",
    zipCode: "59273",
    assignedTo: {
      avatar: "300-34.png",
      name: "Jessica Wright",
    },
    status: "inactive",
    website: "https://user1.com",
    invoiceTemplate: "Template 2",
    customField: "VIP Customer",
    note: "Requested a demo session.",
    allowSecureMessaging: false,
  },
  {
    id: 2,
    firstName: "David",
    MiddleName: "Faith",
    lastName: "Miller",
    HomeNumber: "425-762-3891",
    OfficeNumber: "879-214-6753",
    PhoneNumber: "+1 473 891 236",
    Fax: "273-914-5628",
    email: "user2@example.com",
    address: "287 Main St, Star City",
    state: "New York",
    zipCode: "10487",
    assignedTo: {
      avatar: "300-1.png",
      name: "Sarah Carter",
    },
    status: "active",
    website: "https://user2.com",
    invoiceTemplate: "Template 3",
    customField: "Frequent Buyer",
    note: "Requires invoice customization.",
    allowSecureMessaging: true,
  },
  {
    id: 3,
    firstName: "John",
    MiddleName: "Alice",
    lastName: "Harris",
    HomeNumber: "782-415-6392",
    OfficeNumber: "194-563-7821",
    PhoneNumber: "+1 692 385 741",
    Fax: "385-741-9632",
    email: "user3@example.com",
    address: "635 Elm St, Metropolis",
    state: "Nevada",
    zipCode: "82561",
    assignedTo: {
      avatar: "300-2.png",
      name: "Nathan Fox",
    },
    status: "active",
    website: "https://user3.com",
    invoiceTemplate: "Template 1",
    customField: "Regular Customer",
    note: "Prefers email communication.",
    allowSecureMessaging: false,
  },
  {
    id: 4,
    firstName: "Emma",
    MiddleName: "James",
    lastName: "Johnson",
    HomeNumber: "518-729-4836",
    OfficeNumber: "934-275-6813",
    PhoneNumber: "+1 647 582 319",
    Fax: "392-587-1346",
    email: "user4@example.com",
    address: "264 Pine St, Gotham",
    state: "California",
    zipCode: "92735",
    assignedTo: {
      avatar: "300-3.png",
      name: "Ethan Brooks",
    },
    status: "inactive",
    website: "https://user4.com",
    invoiceTemplate: "Template 3",
    customField: "Premium Member",
    note: "Enjoys online chat support.",
    allowSecureMessaging: true,
  },
  {
    id: 5,
    firstName: "Michael",
    MiddleName: "Scott",
    lastName: "Taylor",
    HomeNumber: "836-254-7391",
    OfficeNumber: "527-349-6182",
    PhoneNumber: "+1 948 637 251",
    Fax: "617-329-5842",
    email: "user5@example.com",
    address: "725 Birch St, Metropolis",
    state: "Texas",
    zipCode: "83672",
    assignedTo: {
      avatar: "300-33.png",
      name: "Guy Hawkins",
    },
    status: "active",
    website: "https://user5.com",
    invoiceTemplate: "Template 2",
    customField: "New Customer",
    note: "Requested a demo session.",
    allowSecureMessaging: true,
  }
];
export { MembersData, tableData };